module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 marker-details"
  }, [_c('h3', [_c('span', {
    staticClass: "highlight"
  }, [_vm._v(_vm._s(_vm.$t('individual_records')))]), _vm._v(" "), _c('Menu')], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-316f1af6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/individual_records/Details.vue
// module id = 1029
// module chunks = 1